import {Distance} from '../../../Domain/Distance';

export function formatAverageDistance(distance: Distance | null): {formatted: string; unit?: string} {
    if (distance === null) {
        return {formatted: '-'};
    }

    const formatter = new Intl.NumberFormat('en-UK', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    });
    return {formatted: formatter.format(distance.meters), unit: 'm'};
}

export function formatDistance(distance: Distance | null): {formatted: string; unit?: string} {
    if (distance === null) {
        return {formatted: ''};
    }

    const formatter = new Intl.NumberFormat('en-UK', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    return {formatted: formatter.format(distance.meters), unit: 'm'};
}

export function formatDistanceCompact(distance: Distance | null): {formatted: string; unit?: string} {
    if (distance === null) {
        return {formatted: '-'};
    }

    //Two digits so 8500m becomes 8.5km
    //500m becomes 0.5k
    //50m becomes 50m
    //5m becomes 5m

    const formatter = new Intl.NumberFormat('en-UK', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    if (distance.meters > 1000) {
        return {formatted: formatter.format(distance.kilometers), unit: 'k'};
    }

    return {formatted: formatter.format(distance.meters), unit: 'm'};
}
